import type { TConsoleColors } from "./types";

export const styles = {
  reset: {
    open: "\u001b[0m",
    close: "\u001b[0m",
  },
  bold: {
    open: "\u001b[1m",
    close: "\u001b[22m",
  },
  dim: {
    open: "\u001b[2m",
    close: "\u001b[22m",
  },
  italic: {
    open: "\u001b[3m",
    close: "\u001b[23m",
  },
  underline: {
    open: "\u001b[4m",
    close: "\u001b[24m",
  },
  overline: {
    open: "\u001b[53m",
    close: "\u001b[55m",
  },
  inverse: {
    open: "\u001b[7m",
    close: "\u001b[27m",
  },
  hidden: {
    open: "\u001b[8m",
    close: "\u001b[28m",
  },
  strikethrough: {
    open: "\u001b[9m",
    close: "\u001b[29m",
  },
  black: {
    open: "\u001b[30m",
    close: "\u001b[39m",
  },
  red: {
    open: "\u001b[31m",
    close: "\u001b[39m",
  },
  green: {
    open: "\u001b[32m",
    close: "\u001b[39m",
  },
  yellow: {
    open: "\u001b[33m",
    close: "\u001b[39m",
  },
  blue: {
    open: "\u001b[34m",
    close: "\u001b[39m",
  },
  magenta: {
    open: "\u001b[35m",
    close: "\u001b[39m",
  },
  cyan: {
    open: "\u001b[36m",
    close: "\u001b[39m",
  },
  white: {
    open: "\u001b[37m",
    close: "\u001b[39m",
  },
  blackBright: {
    open: "\u001b[90m",
    close: "\u001b[39m",
  },
  gray: {
    open: "\u001b[90m",
    close: "\u001b[39m",
  },
  grey: {
    open: "\u001b[90m",
    close: "\u001b[39m",
  },
  redBright: {
    open: "\u001b[91m",
    close: "\u001b[39m",
  },
  greenBright: {
    open: "\u001b[92m",
    close: "\u001b[39m",
  },
  yellowBright: {
    open: "\u001b[93m",
    close: "\u001b[39m",
  },
  blueBright: {
    open: "\u001b[94m",
    close: "\u001b[39m",
  },
  magentaBright: {
    open: "\u001b[95m",
    close: "\u001b[39m",
  },
  cyanBright: {
    open: "\u001b[96m",
    close: "\u001b[39m",
  },
  whiteBright: {
    open: "\u001b[97m",
    close: "\u001b[39m",
  },
  bgBlack: {
    open: "\u001b[40m",
    close: "\u001b[49m",
  },
  bgRed: {
    open: "\u001b[41m",
    close: "\u001b[49m",
  },
  bgGreen: {
    open: "\u001b[42m",
    close: "\u001b[49m",
  },
  bgYellow: {
    open: "\u001b[43m",
    close: "\u001b[49m",
  },
  bgBlue: {
    open: "\u001b[44m",
    close: "\u001b[49m",
  },
  bgMagenta: {
    open: "\u001b[45m",
    close: "\u001b[49m",
  },
  bgCyan: {
    open: "\u001b[46m",
    close: "\u001b[49m",
  },
  bgWhite: {
    open: "\u001b[47m",
    close: "\u001b[49m",
  },
  bgBlackBright: {
    open: "\u001b[100m",
    close: "\u001b[49m",
  },
  bgGray: {
    open: "\u001b[100m",
    close: "\u001b[49m",
  },
  bgGrey: {
    open: "\u001b[100m",
    close: "\u001b[49m",
  },
  bgRedBright: {
    open: "\u001b[101m",
    close: "\u001b[49m",
  },
  bgGreenBright: {
    open: "\u001b[102m",
    close: "\u001b[49m",
  },
  bgYellowBright: {
    open: "\u001b[103m",
    close: "\u001b[49m",
  },
  bgBlueBright: {
    open: "\u001b[104m",
    close: "\u001b[49m",
  },
  bgMagentaBright: {
    open: "\u001b[105m",
    close: "\u001b[49m",
  },
  bgCyanBright: {
    open: "\u001b[106m",
    close: "\u001b[49m",
  },
  bgWhiteBright: {
    open: "\u001b[107m",
    close: "\u001b[49m",
  },
} as const;

export function colorize(s: string, color: TConsoleColors) {
  const { open, close } = styles[color];
  return `${open}${s}${close}`;
}

export class ServerLogger {
  static prepend = "[#] => ";
  static log(msg: string, title: string, color: TConsoleColors) {
    if (typeof window !== "undefined") return;
    const { log } = console;
    const bgColor = `bg${color[0].toUpperCase()}${color.slice(
      1,
    )}` as TConsoleColors;
    log(
      /*"\x1B[1A",*/ colorize(this.prepend, color),
      colorize(title, bgColor),
      msg,
    );
  }
  static info(msg: string, title?: string) {
    this.log(msg, title || "INFO", "blueBright");
  }
  static success(msg: string, title?: string) {
    this.log(msg, title || "SUCCESS", "greenBright");
  }
  static error(msg: string, title?: string) {
    this.log(msg, title || "ERROR", "redBright");
  }
  static warning(msg: string, title?: string) {
    this.log(msg, title || "WARNING", "yellowBright");
  }
}
